// src/i18n/config.ts
// （参考：https://zenn.dev/mtea/articles/react-i18next）

import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector'

export const supportedLngs = ["ja", "en", "cn"];

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .use(LanguageDetector) // ユーザーの言語設定を検知するために必要
  .init({
    fallbackLng: "ja",
    returnEmptyString: false, // 空文字での定義を許可に
    supportedLngs,
    resources: {
      en: {
        translation: require('./locales/en.json')
      },
      ja: {
        translation: require('./locales/ja.json')
      }
      ,cn: {
        translation: require('./locales/cn.json')
      }
    },
    react: {
      // 指定したHTMLノードを翻訳時にそのまま保持して表示するための設定
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span']
    },
    // backend: {
    //   loadPath: "./locales/{{lng}}.json",
    // },
    interpolation: {
      escapeValue: false,
    },
    debug: true,
  });

export default i18n;
